import { store$, store } from "@redux/store";
import { map, filter, distinctUntilChanged, skip } from "rxjs";
import { routingStateActions } from 'features/routing';
import { LocationType } from 'features/searchResultsFacets';

const locationSelector = (state) => state?.searchParameters?.location;

const validLocationTypes = [
  LocationType.County.toString(),
  LocationType.Neighborhood.toString(),
  LocationType.SchoolDistrict.toString(),
  LocationType.City.toString(),
  LocationType.Zip.toString(),
  LocationType.Market.toString(),
  LocationType.RectangularArea.toString(),
  LocationType.State.toString(),
];

const onLocationChange$ = store$.pipe(
  map(locationSelector),
  filter((location) => validLocationTypes.includes(location.locationType)),
  distinctUntilChanged(),
  skip(1));

/**
 * getUrlLocationSegments: Gets the url segments related to the location.
 * For example: tx/austin-area, tx/austin-area/round-rock, tx/houston-area/77433.
 * @param {Object} location Current location information.
 * @returns The url segments related to the location.
 */
const getUrlLocationSegments = (location) => {
    const locationType = location?.locationType;

    const locationSegmentsMap = {
      [LocationType.County.toString()]: `${location.marketState}/${location.marketName}-area/${location.county}-county`,
      [LocationType.City.toString()]: `${location.marketState}/${location.marketName}-area/${location.city}`,
      [LocationType.Neighborhood.toString()]: `${location.marketState}/${location.marketName}-area/${location.city}/neighborhood-${location.neighborhood}`,
      [LocationType.SchoolDistrict.toString()]: `${location.marketState}/${location.marketName}-area/schools-${location.schoolDistrictName}`,
      [LocationType.Zip.toString()]: `${location.marketState}/${location.marketName}-area/${location.zip}`,
      [LocationType.Market.toString()]: `${location.marketState}/${location.marketName}-area`,
      [LocationType.State.toString()]: `${location.geoLocationState}`,
      [LocationType.RectangularArea.toString()]:
          `map?coordinates=${location.minimumLatitude},${location.minimumLongitude},${location.maximumLatitude},${location.maximumLongitude}`,
    };

    const urlLocationSegments = locationSegmentsMap[locationType];
    return urlLocationSegments.toLowerCase().replaceAll(' ','-');
}

/**
 * updateUrlOnLocationChanged: Updates the url location segments on store.
 * @param {Object} location Current location information.
 */
const updateUrlOnLocationChanged = (location) => {
  const newLocationSegments = getUrlLocationSegments(location);
  store.dispatch(routingStateActions.updateLocation(newLocationSegments));
};

onLocationChange$.subscribe(updateUrlOnLocationChanged);